module.exports = __webpack_public_path__ + "static/media/Outdoor_3.d30a41fc.jpg";